import { render, staticRenderFns } from "./QuestionVersionSwitcher.vue?vue&type=template&id=cb5a294e&scoped=true&"
import script from "./QuestionVersionSwitcher.vue?vue&type=script&lang=js&"
export * from "./QuestionVersionSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./QuestionVersionSwitcher.vue?vue&type=style&index=0&id=cb5a294e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5a294e",
  null
  
)

export default component.exports